import React, { useState, useEffect } from "react"

const ThemeChanger = () => {
    const [themeState, setThemeState] = useState("theme-light");

    const handleChange = () => {
        setThemeState(!themeState);
        if (themeState) {
            localStorage.setItem("Theme", "dark");
            document.body.classList.remove("theme-light");
            document.body.classList.add("theme-dark");

        } else {
            localStorage.setItem("Theme", "light");
            document.body.classList.remove("theme-dark");
            document.body.classList.add("theme-light");
        }
    }
    useEffect(() => {
        let getTheme = localStorage.getItem("Theme");
        if(!getTheme) {
            localStorage.setItem("Theme", "light");
            getTheme = "light";
        }
        if (getTheme === "dark") return document.body.classList.add("theme-dark");
        if (getTheme === "light") return document.body.classList.add("theme-light");
    })
    return (
        <div>
            {/* <button onClick={handleChange} className="btn-toggle " aria-label="Change Theme" /> */}
        </div>
    )
}

export default ThemeChanger;